import(/* webpackMode: "eager", webpackExports: ["SimulatePreloadedQuery"] */ "/codebuild/output/src821806899/src/faculdademetropolitana/node_modules/@apollo/client-react-streaming/dist/index.cc.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/codebuild/output/src821806899/src/faculdademetropolitana/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src821806899/src/faculdademetropolitana/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src821806899/src/faculdademetropolitana/src/components/FormPosts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src821806899/src/faculdademetropolitana/src/components/GalleryPosts.tsx");
